import React from "react"
import { ContentfulPage } from "#/features/contentful/contentful-page"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"
import useCarrotPlan from "#/components/carrot-plans/hooks/useCarrotPlan"
import useGetUserInfoConditionsSubset from "#/services/user/hooks/useGetCurrentUserConditionsSubset"

export function BlueberryPediatricsPage(): JSX.Element {
  const { hasCarrotPlan, isLoading: isCarrotPlanLoading } = useCarrotPlan()
  const { data: userInfo, isLoading: isUserInfoLoading } = useGetUserInfoConditionsSubset()

  return (
    <ContentfulPage
      entryId={StaticAssetID.BLUEBERRY_PEDIATRICS_PAGE}
      flagEnabled={true}
      pageViewTracking={{
        isLoading: isCarrotPlanLoading || isUserInfoLoading,
        metadata: { hasCarrotPlan, hasCarrotPlanOnTheWay: userInfo?.hasCarrotPlanOnTheWay }
      }}
    />
  )
}
